"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createVimeoContentStyle;

function createVimeoContentStyle(_ref) {
  var videoHeight = _ref.videoHeight;
  return {
    border: 0,
    height: videoHeight,
    width: '100%'
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvVmltZW9Db250ZW50LnRzIl0sIm5hbWVzIjpbImNyZWF0ZVZpbWVvQ29udGVudFN0eWxlIiwidmlkZW9IZWlnaHQiLCJib3JkZXIiLCJoZWlnaHQiLCJ3aWR0aCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUVlLFNBQVNBLHVCQUFULE9BQXNFO0FBQUEsTUFBbkNDLFdBQW1DLFFBQW5DQSxXQUFtQztBQUNuRixTQUFPO0FBQ0xDLElBQUFBLE1BQU0sRUFBRSxDQURIO0FBRUxDLElBQUFBLE1BQU0sRUFBRUYsV0FGSDtBQUdMRyxJQUFBQSxLQUFLLEVBQUU7QUFIRixHQUFQO0FBS0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFN0cmljdFN0eWxlT3B0aW9ucyB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWFwaSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNyZWF0ZVZpbWVvQ29udGVudFN0eWxlKHsgdmlkZW9IZWlnaHQgfTogU3RyaWN0U3R5bGVPcHRpb25zKSB7XG4gIHJldHVybiB7XG4gICAgYm9yZGVyOiAwLFxuICAgIGhlaWdodDogdmlkZW9IZWlnaHQsXG4gICAgd2lkdGg6ICcxMDAlJ1xuICB9O1xufVxuIl19